
import React from 'react';
import axios2 from 'services/axios2';

import {useParams, Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import NuDropdown from 'components/nubox/NuDropdown';
import NuInput from 'components/nubox/NuInput';
import NuListRadio from 'components/nubox/NuListRadio';
import NuLoading from 'components/nubox/NuLoading';


import ImageUploadSingle from 'components/nubox/ImageUploadSingle';

//import listac from '../assets/img/lista2.png';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from 'reactstrap';


const formInitial = {
  idd:0,
  ope:'n',
  
  id_doc:'',
  nro_doc:'',
  ap_pat:'',
  ap_mat:'',
  nombres:'',
  tel:'',
  fecha_naci:'',
  dir:'',
  email:'',
  username:'',
  estado:1,     
};
//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class ModalDocente extends React.Component {
  state = {
    isloaging:false,
    modalInsertar:false,
    form: formInitial,
    
    grupos:[], /* combo grupos */
    estados:[ { value:0, label: "Inactivo",color:"#da4a43"  },
      { value:1, label: "Activo", color:"#008ffb" },
    ],
  };
  //------------------------------------------------------
  componentDidMount() {
    console.log('componentDidMount Modal');
    //--limpiamos el array de prueba
        
    this.cargar_grupos();
        
    //---------
    this.limpiar();
  }
  //-------------------
  limpiar = () =>{
    this.setState({form: formInitial});
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    if(e.target.type==="checkbox"){
      //console.log("cheched:"+ e.target.checked);
      let res = e.target.checked? 1:0;
      console.log("value:"+ res);
      
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //----cargamos combo
  cargar_grupos = async() => {
    let param = { }
    await axios2.post('cbo_grupos', param).then(res => {
        if(res.data.length>0){ 
            this.setState({grupos: res.data});
        }else{
          toast.error('No existen datos');
        }
    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
    });
  };
  //======================================================
  showModal = () => {
    //setModalOpen(true);
    this.setState({ modalInsertar: true});
  }
  closeModal = () => {
    //setModalOpen(true);
    this.setState({ modalInsertar: false});
  }
  //---------------
  nuevo =() =>{
    console.log('nuevo');
    //this.limpiar();
    
    this.setState({
      form: {
        ...formInitial,
        id: 0,
        ope:'n'
      },
      modalInsertar: true,
    });
  }
  //---------------
  editar =(idd)=>{
    console.log('editar');
    let param = { idd: idd, ope:'f'  }
    
    axios2.post( 'docente_store' , param).then(res => {
      console.log(res.data);

        if(res.data !== null){               
            //---asignamos los valores
            this.setState({
              form: {
                ...res.data,
                'idd': idd,
                'ope': 'e',
              },
              modalInsertar: true, /* show modal */
            });

            //----
        }else{
          toast.error('No existen datos');
        }

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });
  }
  //----------------------------
  eliminar =(idd)=>{
    console.log('------eliminar->');
    let param = {  
      idd: idd,
      ope:'x'
    }
    console.log(param);
    axios2.post( 'docente_store', param).then(res => {
      console.log(res.data);

        if(res.data.exito===1){ 
            this.limpiar();
            this.closeModal();
            toast.success('Eliminado con exito');
            this.props.okModal(); //callback
        }else{
          toast.error('Error al eliminar registro', {
            position: toast.POSITION.TOP_RIGHT
          });
        }

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });
  }
  //----------------------------
  validar = () =>{
    if( this.state.form.id_espe===0){
      toast.error( 'Especialidad no valido', {position: toast.POSITION.TOP_RIGHT});
      return true;
    }
  }
  /************************************************ */
  okImage = (filename) =>{    
    this.setState({ form:{...this.state.form, foto_path1: filename}}); 
  }
  cancelImage = () =>{
    //---ocultamos la ventana
    this.setState({ form:{...this.state.form, foto_path1: '' }}); 
  }
    //----------------------------
   
  //----------------------------
  formSave = () => {
    /*let error = this.validar();
    if(error===true){
      return;
    }*/
    
    let param = this.state.form;
    //param.id_rol = 2; //por ser docente
    console.log(param);
    this.setState({isloaging:true})

    axios2.post('docente_store', param).then(res => {
        let response = res.data;
        this.setState({isloaging:false})
        
        if(response.exito===1){ 
            
          toast.success( response.mensaje, {position: toast.POSITION.TOP_RIGHT});
          //---llamamos a la funcion externa
          this.props.okModal();
          this.closeModal();
        }else{

          toast.error( response.mensaje, {position: toast.POSITION.TOP_RIGHT});
        }

    }).catch(error => {
        alert('Bad Request');
        console.log(error);
        
    });

  }
  //---------------------------
  render() {
  
    return (
      <div>
        <ToastContainer />
        
        {/*--- modal---- */}
        <Modal isOpen={this.state.modalInsertar} toggle={this.closeModal} >
          <ModalHeader toggle={this.closeModal} 
            className= { (this.state.form.ope==='n'? 'header-verde':'header-naranja') + ' ' + (this.state.form.ope==='n'? "color:'#45b545'":"color:'#343b43'")  } 
          >
            <h4 className="modal-title">
            { this.state.form.ope==='n'
              ? "Nuevo"
              : "Editar"
            } Docente
            </h4>
          </ModalHeader>

          <ModalBody style={{background: "#F7F7F7"}}>
                              
            <form  method='POST'>
      

              <div className=' row'>
                <div className='col-md-6'>
                  <label htmlFor='id_u' className='col-lg-3 control-label'><b>Cod. Doc.</b></label>      
                  <input
                    type='text'
                    name='id_doc'
                    value={this.state.form.id_doc}
                    onChange={this.handleChangeForm}
                    className='form-control'
                    disabled={true}
                  />
    
                </div>
                <div className='col-md-6'>
                  
                </div>
              </div>

              <div className='form-group row'>
                  
                  <div className='col-md-6'>
                    <label htmlFor='nro_doc' className='col-lg-3 control-label'><b>C.I.</b></label>
                    <NuInput                        
                      className=' form-control' 
                      type='text'
                      name='nro_doc' 
                      value={this.state.form.nro_doc}
                      onChange={this.handleChangeForm}
                      classOK=''
                      classError='is-invalid'
                      valtipo='string2'
                    />
                
                  </div>

                  <div className='col-md-6'>
                    <label htmlFor='fecha_naci' className='control-label'><b>Fecha Nacimiento</b></label>
                    <input
                      type='date'
                      name='fecha_naci'
                      value={this.state.form.fecha_naci}
                      onChange={this.handleChangeForm}
                      className='form-control'
                    />
      
                    
                  </div>
              </div>

              <div className='row'>
                <div className='col-md-6'>
                    <label htmlFor='ap_pat' className='col-lg-3 control-label'><b>Paterno</b></label>
                      
                    <NuInput                        
                      className='form-control' 
                      type='text'
                      name='ap_pat' 
                      value={this.state.form.ap_pat}
                      onChange={this.handleChangeForm}
                      classOK=''
                      classError='is-invalid'
                      inputStyle={{textTransform: 'uppercase'}}
                      valtipo='string2'
                    />
                    
                </div>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='ap_mat' className='col-lg-3 control-label'><b>Materno</b></label>    
                    <NuInput                        
                      className='form-control' 
                      type='text'
                      name='ap_mat' 
                      value={this.state.form.ap_mat}
                      onChange={this.handleChangeForm}
                      classOK=''
                      classError='is-invalid'
                      inputStyle={{textTransform: 'uppercase'}}
                      valtipo='string2'
                    />
    
                  </div>
                </div>

              </div>
             
              <div className='form-group row'>
                  <label htmlFor='nombres' className='col-lg-3 control-label'><b>Nombres</b></label>
                  <div className='col-lg-9'>
                      
                    <NuInput                        
                      className='form-control' 
                      type='text'
                      name='nombres' 
                      value={this.state.form.nombres}
                      onChange={this.handleChangeForm}
                      classOK=''
                      classError='is-invalid'
                      inputStyle={{textTransform: 'uppercase'}}
                      valtipo='string2'
                    />
    
                  </div>
              </div>
          <div className='top_title2'>
            <h4 className=''>Datos</h4>
          </div>
          
              <div className='form-group row'>
                  <label htmlFor='tel' className='col-lg-3 control-label'><b>Telf.</b></label>
                  <div className='col-lg-9'>
                      
                  <NuInput                        
                    className='form-control' 
                    type='text'
                    name='tel' 
                    value={this.state.form.tel}
                    onChange={this.handleChangeForm}
                    classOK=''
                    classError='is-invalid'
                    valtipo='string2'
                  />
    
                  </div>
              </div>
              <div className='form-group row'>
                  
              </div>
              <div className='form-group row'>
                  <label htmlFor='dir' className='col-lg-3 control-label'><b>Dirección</b></label>
                  <div className='col-lg-9'>
                      
                  <NuInput                        
                    className='form-control' 
                    type='text'
                    name='dir' 
                    value={this.state.form.dir}
                    onChange={this.handleChangeForm}
                    classOK=''
                    classError='is-invalid'
                    valtipo='string2'
                  />
    
                  </div>
              </div>
              <div className='form-group row'>
                  <label htmlFor='email' className='col-lg-3 control-label'><b>Email</b></label>
                  <div className='col-lg-9'>
                      
                  <input
                    type='text'
                    name='email'
                    value={this.state.form.email}
                    onChange={this.handleChangeForm}
                    className='form-control'
                    autoComplete='off'
                  />
                      
                  </div>
              </div>
              
              <div className='form-group row'>
                  <label htmlFor='username' className='col-lg-3 control-label'><b>Username</b></label>
                  <div className='col-lg-9'>
                      
                  <input
                    type='text'
                    name='username'
                    value={this.state.form.username}
                    onChange={this.handleChangeForm}
                    className='form-control'
                    autoComplete='off'
                  />
                      
                  </div>
              </div>

              <div className='form-group row'>
                  <label htmlFor='password' className='col-lg-3 control-label'><b>Estado</b></label>
                  <div className='col-lg-9'>
                      
                  <NuListRadio
                      options={this.state.estados}
                      name="estado"
                      value={this.state.form.estado}
                      onChange={this.handleChangeForm}
                      isHorizontal = {true}
                    />
    
                  </div>
              </div></form>
      
            
          </ModalBody>
          <ModalFooter>
            <NuLoading text="Cargando...." show= { this.state.isloaging }/>
            <Button color='primary' onClick={ this.formSave}>Guardar</Button>{' '}
            <Button color='secondary' onClick={this.closeModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

//------------
export default ModalDocente;

